import { Box, Typography, useTheme } from '@mui/material';
import { IconPostCall } from '@shared/assets/images/svgs';
import { UserRolesEnum } from '@shared/constants/auth.constants';
import { CampaignStatus } from '@shared/services/apiService';
import { CampaignRunStatusType } from '@shared/services/apiService/missing-types';
import { RootState, useAppSelector } from '@shared/store';
import { t } from 'i18next';
import React from 'react';
import CampaignWebhookSection from './components/CampaignWebhookSection';

interface SettingsTabProps {
  campaignId: string | null | undefined;
  isCampaignActive: CampaignStatus;
}

const SettingsTab: React.FC<SettingsTabProps> = ({
  campaignId,
  isCampaignActive,
}: SettingsTabProps) => {
  const theme = useTheme();
  const currentUser = useAppSelector((state: RootState) => state.auth.authenticatedUser);

  return (
    <Box
      sx={{
        padding: '30px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '12px',
          'svg path': {
            stroke: theme.palette.getContrastText(theme.palette.background.default),
          },
        }}>
        <IconPostCall />
        <Typography fontSize="18px" fontWeight={600}>
          {t('campaignPage.editCampaign.webhooks')}
        </Typography>
      </Box>

      {campaignId && (
        <CampaignWebhookSection
          campaignId={campaignId}
          isDisabled={
            isCampaignActive !== CampaignRunStatusType.INACTIVE ||
            currentUser?.role === UserRolesEnum.VIEWER
          }
        />
      )}
    </Box>
  );
};

export default SettingsTab;
